import React from "react";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import styles from "./url-fieldSelector.module.scss";

const UrlFieldSelector = ({
  placeholder,
  fieldList,
  selectedField,
  appendSelectedField,
  onFieldChange,
  remove,
}) => {
  return (
    <div className={styles["select-item"]}>
      <Button
        title="append"
        onClick={appendSelectedField}
        disabled={!selectedField}
        size="small"
      >
        {" "}
        Add
      </Button>
      <Button
        title="delete"
        onClick={remove}
        disabled={!selectedField}
        size="small"
      >
        {" "}
        Delete
      </Button>
      <Select
        className={styles.select}
        labelId="field-select-1"
        id="field-select-1"
        value={selectedField}
        displayEmpty
        renderValue={selectedField !== "" ? undefined : () => placeholder}
        onChange={onFieldChange}
      >
        {fieldList &&
          fieldList.map((field) => (
            <MenuItem key={field.id} value={field.label}>
              {field.label}
            </MenuItem>
          ))}
      </Select>
    </div>
  );
};

export default UrlFieldSelector;
